/** Copy and tag styles shared by the Admin Console sections. */

export const ENTER_WORKSPACE_LABEL = 'Enter workspace';
export const VIEW_WORKSPACE_LABEL = 'View details';
export const NEW_WORKSPACE_LABEL = 'New workspace';
export const WORKSPACE_NAME_REQUIRED = 'Please enter a workspace name.';

/** `TagColored` variant per workspace status. */
export const WORKSPACE_STATUS_TAG = {
    active: { label: 'Active', variant: 'lime' },
    archived: { label: 'Archived', variant: 'disabled' },
};

/** `TagColored` variant per coupon display status (see `couponStatusOf`). */
export const COUPON_STATUS_TAG = {
    active: { label: 'Active', variant: 'lime' },
    exhausted: { label: 'Fully redeemed', variant: 'cyan' },
    expired: { label: 'Expired', variant: 'disabled' },
    revoked: { label: 'Revoked', variant: 'volcano' },
};

/**
 * Display status of a coupon: revoked wins, then expired, then "fully
 * redeemed" once every allowed redemption was used, otherwise active.
 */
export function couponStatusOf(coupon) {
    if (!coupon) return 'active';
    if (coupon.status === 'revoked') return 'revoked';
    if (coupon.expired) return 'expired';
    const cap = Number(coupon.max_redemptions);
    if (Number.isFinite(cap) && cap > 0 && Number(coupon.redemption_count) >= cap) return 'exhausted';
    return 'active';
}
